module.exports = __webpack_public_path__ + "img/htkj_14.ada67228.jpg";